/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
// Extending From
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
// Ember Imports
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import { Upload } from 'tus-js-client';
import config from '@linc-technologies/linced-common/utils/config';
// Internal Imports
import MediaType from '../enums/media-type';
import { isMobile } from '../utils/platform';

export default class ExpandableFab extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  // Attrs

  // Services
  @service
  toaster;

  // State
  @tracked
  isOpen = false;

  @tracked
  showingProgress = false;
  @tracked
  remaining = 0;
  @tracked
  isMobile = false;

  didInsertElement() {
    super.didInsertElement(...arguments);

    this.isMobile = isMobile();
  }

  // Functions
  // editAction is a passed in function (i.e. open up a create a new post dialog)
  editAction = null;

  createMediaPost = null;

  @action
  toggle(e) {
    e.stopPropagation();
    if (!this.isOpen) {
      this.isOpen = true;
    }
  }

  @action
  handleClick() {
    this.close();
    this.editAction();
  }

  @action
  close() {
    if (this.isOpen) {
      this.isOpen = !this.isOpen;
    }
  }

  @action
  open() {
    this.isOpen = true;
  }

  @action
  passToGooglePicker() {
    this.launchGooglePicker(true);
  }

  @action
  mediaUploaded(elementId) {
    const endpoints = config.APP.endpoints;

    let fileInput = document.querySelector(`#${elementId}`);
    if (isEmpty(fileInput) || isEmpty(fileInput.files)) {
      return;
    }

    let file = fileInput.files[0];
    if (isEmpty(file)) {
      return;
    }

    this.showingProgress = true;

    var upload = new Upload(file, {
      endpoint: endpoints.tus,
      retryDelays: [0, 3000, 5000, 10000, 20000],
      metadata: {
        filename: file.name,
        filetype: file.type,
      },
      onError: () => {
        this.toaster.error('Error uploading media!');
        this.showingProgress = false;
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        let percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        this.remaining = `${percentage}%`;
      },
      onSuccess: () => {
        this.showingProgress = false;

        let key = upload.url.match(/files\/(.+)\+/)[1];
        let type =
          MediaType.getValue(file.type.split('/')[0]) || MediaType.FILE;

        this.createMediaPost(file, upload, key, type);
        this.close();
      },
    });

    // Start the upload
    upload.start();
  }
}
